module.exports = __webpack_public_path__ + "img/8.463c8a7b.jpg";